import _ from 'underscore';
import Promise from 'bluebird';
import { getEditorialTemplates, ENTITY } from '@bingads-webui-campaign/delivery-status-popup-factory';
import { getFwdLinkId } from '@bingads-webui-campaign/api-errors';
import { getAppealRejections } from './get-editorial-reasons';

export function getEditorialReasonsTemplate({
  i18n,
  commonI18n,
  ajaxOptions,
  attributeId,
  valueLevel,
  instrumentation,
  permissions,
}, deliveryStatus) {
  return new Promise((resolve) => {
    // send request to fetch editorial reasons
    getAppealRejections({
      attributeId, ajaxOptions, valueLevel,
    }).then((response) => {
      let reasons = [];
      const { value } = response || {};
      if (value && !_.isEmpty(value) && !_.isEmpty(value[0].Reasons)) {
        reasons = value[0].Reasons;
      }

      const options = {
        reasons,
        i18n,
        commonI18n,
        instrumentation,
        ajaxOptions,
        editorialRejection: {
          getFwdLinkId,
        },
        errI18n: i18n,
        locationI18n: i18n,
        entity: ENTITY.CUSTOMIZERFEED,
        deliveryStatus,
        permissions,
      };

      const reasonTemplates = getEditorialTemplates(options);

      resolve(reasonTemplates);
    });
  });
}
